import React, { useCallback, useEffect, useState } from 'react';
import { useWindowDimensions } from 'hooks';
import { size as BREAKPOINTS } from '_constants/DEVICES';
import MobileChrome from './MobileChrome';

import Rail from './Rail';
import TopBar from './TopBar';
import CommandPalette from './CommandPalette';

const MOBILE_BREAKPOINT = parseInt(BREAKPOINTS.tableView, 10);

const Navigation = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < MOBILE_BREAKPOINT;
  const [paletteOpen, setPaletteOpen] = useState(false);

  const openPalette = useCallback(() => setPaletteOpen(true), []);
  const closePalette = useCallback(() => setPaletteOpen(false), []);

  useEffect(() => {
    if (isMobile) return undefined;
    const handleKey = (e) => {
      const isShortcut = (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K');
      if (!isShortcut) return;
      e.preventDefault();
      setPaletteOpen((prev) => !prev);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isMobile]);

  if (isMobile) {
    return <MobileChrome />;
  }

  return (
    <>
      <Rail />
      <TopBar onOpenPalette={openPalette} />
      {paletteOpen && <CommandPalette onClose={closePalette} />}
    </>
  );
};

export default Navigation;
